export default "/images/vendor/flag-icons/flags/4x3/uz.svg?7ed400a6435c85b5b8900c1bb9dc79d8";